import { TYPE_NONE } from "@components/Form";

import type { Input } from "../types";

const FIELD_NAMES = [
  "isLiabilityAccepted",
  "hasPurchasedExemptSecurities",
  "membershipInterestsTitle",
  "name",
  "entityType",
  "title",
  "address",
  "isDisregardedForTaxPurposes",
  "taxFilingStatus",
  "hasEinNumber",
  "einNumber",
  "ssnNumber",
  "isRetirementPlan",
  "beneficialOwnerName",
  "beneficialOwnerAddress",
  "beneficialOwnerEinNumber",
  "beneficialOwnerSsnNumber",
  "beneficialOwnerEntityType",
  "beneficialOwnerTaxFilingStatus",
  "beneficialOwnerCustodianEinNumber",
  "isUsCitizen",
  "isUsPerson",
  "hasOtherUsResidenceState",
  "residenceState",
  "hasSsn",
];

// Every entity profile field as a hidden input, keyed by the field name.
const getProfileEntityInputsMap = (): Record<string, Input> => {
  const inputsMap: Record<string, Input> = {};

  for (const name of FIELD_NAMES) {
    inputsMap[name] = { name, type: TYPE_NONE };
  }

  return inputsMap;
};

export default getProfileEntityInputsMap;
